var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import DeprecatedSelect from "../../src/View/UI/DeprecatedSelect/DeprecatedSelect";
import { getSurveyAdminDetailsPath } from "../../src/View/Pages/Admin/Survey/AdminSurveyRoutes";
import { getXSRF } from "../../src/Services/Shared/FetchService";
class SurveyConfigurator extends Component {
    constructor() {
        // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
        super();
        this.state = {
            externalSurveys: [],
            selectedSurveyId: null,
            addedSurveys: [],
            errorMessage: null,
            showSuccessMessage: false,
            showErrorMessage: false,
            isLoadingAddedSurveys: false,
            triedToLoadExternalSurveys: false,
            isAddingSurvey: false,
        };
        // @ts-expect-error - TS2339 - Property 'getExternalSurveysTimeout' does not exist on type 'SurveyConfigurator'.
        this.getExternalSurveysTimeout = null;
        this.getExternalSurveys = this.getExternalSurveys.bind(this);
        this.onSelectedSurveyChange = this.onSelectedSurveyChange.bind(this);
        this.addSelectedSurvey = this.addSelectedSurvey.bind(this);
    }
    componentDidMount() {
        this.getAddedSurveys();
    }
    // @ts-expect-error - TS7006 - Parameter 'input' implicitly has an 'any' type.
    getExternalSurveys(input) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO refactor this.  Async methods always return a promise.
            // eslint-disable-next-line no-async-promise-executor
            const p = new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                // @ts-expect-error - TS2339 - Property 'getExternalSurveysTimeout' does not exist on type 'SurveyConfigurator'.
                clearTimeout(this.getExternalSurveysTimeout);
                // @ts-expect-error - TS2339 - Property 'getExternalSurveysTimeout' does not exist on type 'SurveyConfigurator'.
                this.getExternalSurveysTimeout = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                    try {
                        const response = yield this.fetchExternalSurveys(input);
                        this.setState({
                            externalSurveys: response.surveys,
                            errorMessage: response.errorMessage,
                            triedToLoadExternalSurveys: true,
                        });
                        resolve({
                            // @ts-expect-error - TS7006 - Parameter 's' implicitly has an 'any' type.
                            options: response.surveys.map((s) => ({
                                label: s.title,
                                id: s.id,
                                survey: s,
                            })),
                        });
                    }
                    catch (err) {
                        this.setState({ triedToLoadExternalSurveys: true });
                        reject(err);
                    }
                }), 200);
            }));
            return p;
        });
    }
    getAddedSurveys() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setState({ isLoadingAddedSurveys: true });
            const surveys = yield this.fetchAddedSurveys();
            this.setState({
                addedSurveys: surveys,
                isLoadingAddedSurveys: false,
            });
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'titleSearch' implicitly has an 'any' type.
    fetchExternalSurveys(titleSearch) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = "/aviso/surveyAdmin/externalSurveys";
            if (titleSearch) {
                url += `?titleSearch=${titleSearch}`;
            }
            const response = yield fetch(url, {
                credentials: "include",
            });
            const result = yield response.json();
            return result;
        });
    }
    fetchAddedSurveys() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch("/aviso/surveyAdmin/surveys", {
                credentials: "include",
            });
            const result = yield response.json();
            return result.surveys;
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'selectedOption' implicitly has an 'any' type.
    onSelectedSurveyChange(selectedOption) {
        this.setState({
            selectedSurvey: selectedOption,
        });
    }
    addSelectedSurvey() {
        return __awaiter(this, void 0, void 0, function* () {
            // Reset error and success messages
            this.setState({
                showSuccessMessage: false,
                showErrorMessage: false,
                errorMessage: null,
                isAddingSurvey: true,
            });
            // @ts-expect-error - TS2339 - Property 'selectedSurvey' does not exist on type 'Readonly<{}>'.
            if (!this.state.selectedSurvey) {
                // TODO: show some sort of error message
                return;
            }
            // add the survey.
            const response = yield fetch("/aviso/surveyAdmin/addExternalSurvey", {
                credentials: "include",
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-XSRF-TOKEN": getXSRF(),
                    Accept: "application/json",
                },
                body: JSON.stringify({
                    // @ts-expect-error - TS2339 - Property 'selectedSurvey' does not exist on type 'Readonly<{}>'.
                    srcSystemId: this.state.selectedSurvey.id,
                    // @ts-expect-error - TS2339 - Property 'selectedSurvey' does not exist on type 'Readonly<{}>'.
                    displayName: this.state.selectedSurvey.label,
                }),
            });
            const result = yield response.json();
            if (result.success) {
                this.setState({
                    showSuccessMessage: true,
                    showErrorMessage: false,
                    errorMessage: null,
                    isAddingSurvey: false,
                });
            }
            else {
                this.setState({
                    showSuccessMessage: false,
                    showErrorMessage: true,
                    errorMessage: result.message,
                    isAddingSurvey: false,
                });
            }
            this.getAddedSurveys();
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            this.getExternalSurveys();
        });
    }
    render() {
        return (_jsxs("div", { className: "container-fluid pb-3 pt-3", children: [_jsx("div", { className: "title-block", children: _jsxs("h1", { className: "title", children: ["Surveys (", this.state.addedSurveys ? this.state.addedSurveys.length : 0, ")"] }) }), this.state.showSuccessMessage && (_jsxs("div", { className: "alert alert-success", children: [_jsx("span", { "aria-hidden": "true", className: "fa fa-check-circle" }), " Survey added!"] })), this.state.showErrorMessage && (_jsxs("div", { className: "alert alert-danger", children: [_jsx("span", { "aria-hidden": "true", className: "fa fa-exclamation-triangle" }), " ", "There was a problem saving the survey:", _jsx("br", {}), this.state.errorMessage] })), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "surveySelect", children: "Add Survey" }), _jsx(DeprecatedSelect.Async, { id: "surveySelect", "aria-label": "Add Survey", loadOptions: this.getExternalSurveys, multi: false, onChange: this.onSelectedSurveyChange, 
                            // @ts-expect-error - TS2339 - Property 'selectedSurvey' does not exist on type 'Readonly<{}>'.
                            value: this.state.selectedSurvey }), this.state.triedToLoadExternalSurveys &&
                            // @ts-expect-error - TS2339 - Property 'externalSurveys' does not exist on type 'Readonly<{}>'.
                            !this.state.externalSurveys.length && (_jsx("small", { children: "No surveys found." }))] }), _jsx("div", { className: "form-group", children: _jsxs("button", { className: "btn btn-primary", disabled: 
                        // @ts-expect-error - TS2339 - Property 'isAddingSurvey' does not exist on type 'Readonly<{}>'.
                        this.state.isAddingSurvey ||
                            // @ts-expect-error - TS2339 - Property 'selectedSurvey' does not exist on type 'Readonly<{}>'.
                            !this.state.selectedSurvey ||
                            // @ts-expect-error - TS2339 - Property 'selectedSurvey' does not exist on type 'Readonly<{}>'.
                            !this.state.selectedSurvey.id, onClick: this.addSelectedSurvey, type: "button", children: [this.state.isAddingSurvey ? (_jsx("span", { "aria-hidden": "true", className: "fal fa-circle-notch fa-spin" })) : (_jsx("span", { "aria-hidden": "true", className: "fa fa-plus" })), " ", "Add"] }) }), this.state.isLoadingAddedSurveys ? (_jsxs("div", { children: [_jsx("span", { "aria-hidden": "true", className: "fal fa-circle-notch fa-spin" }), _jsx("span", { className: "sr-only", children: "Loading..." })] })) : (_jsxs("div", { children: [!this.state.addedSurveys.length && (_jsxs("div", { className: "alert alert-info", children: [_jsx("span", { className: "fa fa-info-circle" }), " You have not added any surveys."] })), _jsxs("table", { className: "table table-striped table-bordered table-hover", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Name" }), _jsx("th", { children: "Sync Enabled" }), _jsx("th", { children: "Key Engagement" })] }) }), _jsx("tbody", { children: this.state.addedSurveys.map((survey) => (_jsxs("tr", { children: [_jsx("td", { children: _jsx(Link, { to: getSurveyAdminDetailsPath(survey.id), children: survey.displayName }) }), _jsx("td", { children: survey.syncEnabled ? "Yes" : "No" }), _jsx("td", { children: survey.isKeyEngagement ? "Yes" : "No" })] }, survey.id))) })] })] }))] }));
    }
}
export default SurveyConfigurator;
